import gql from 'graphql-tag'

export const TEMPLATE = gql`
  query file_template($name: String!) {
    file_template(name: $name) {
      name data
  }
}
`
